import { useQuery } from '@tanstack/react-query';

import { listEmployees } from '@/api/employee-api';

const EMPLOYEES_KEY = ['employees'] as const;

function employeesKey(siteIds: string[] | undefined) {
  return siteIds && siteIds.length > 0
    ? ([...EMPLOYEES_KEY, { siteIds: [...siteIds].sort() }] as const)
    : (EMPLOYEES_KEY as readonly unknown[]);
}

/**
 * Lists employees, optionally filtered to one or more sites. The
 * wizard's specific-assignment shift modal passes the active template's
 * site set so the picker only offers workers who can actually be
 * assigned. Sort the site list into the cache key so a permutation
 * isn't treated as a different query.
 */
export function useEmployees(siteIds?: string[]) {
  return useQuery({
    queryKey: employeesKey(siteIds),
    queryFn: () => listEmployees(siteIds),
  });
}
